import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import {FeedbacksTableDetail} from "../../../features/manageFeedbacks/manageFeedbacksTypes"
import { getFilteredFeedbacks } from "../../../features/manageFeedbacks/manageFeedbacksService";
import { TranslationEnum, usePortalTranslation } from "../../../providers/TranslationProvider";


interface Props {
  data: FeedbacksTableDetail[];
  searchQuery: string;
  onAssignClick: (id: string) => void;
  onViewClick: (id: string) => void;
  typeAndStatusFilter : Record<string, string>;
}

const FeedbacksTable: React.FC<Props> = ({
  data,
  searchQuery,
  onAssignClick,
  onViewClick,
  typeAndStatusFilter
}) => {
  const { translate } = usePortalTranslation();

  const filteredData :FeedbacksTableDetail[] = getFilteredFeedbacks(data, typeAndStatusFilter, searchQuery);

  const columns: GridColDef[] = [
    { field: "name", headerName: translate(TranslationEnum.manage_feedbacks, "Name"), width: 200 },
    { field: "creation_time", headerName: translate(TranslationEnum.manage_feedbacks, "Submission Time"), width: 200 },
    { field: "feedbackType", headerName: translate(TranslationEnum.manage_feedbacks, "Feedback Type"), width: 150 },
    { field: "complaint", headerName: translate(TranslationEnum.manage_feedbacks, "Query Reason"), width: 300 },
    { field: "remarks", headerName: translate(TranslationEnum.manage_feedbacks, "Remarks"), width: 200 },
    { field: "status", headerName: translate(TranslationEnum.manage_feedbacks, "Status"), width: 150 },
    { field: "assignedTo", headerName: translate(TranslationEnum.manage_feedbacks, "Assigned To"), width: 200 },
    {
      field: "image",
      headerName: translate(TranslationEnum.manage_feedbacks, "Image"),
      width: 100,
      renderCell: (params) => (
        <img
          src={params.row.blob_key}
          alt={params.row.image_name}
          style={{ width: "50px" }}
        />
      ),
    },
    {
      field: "assign",
      headerName: translate(TranslationEnum.manage_feedbacks, "Assign"),
      width: 80,
      renderCell: (params) => (
        <Button onClick={() => onAssignClick(params.row.id)}>{translate(TranslationEnum.manage_feedbacks, "Assign")}</Button>
      ),
    },
    {
      field: "view",
      headerName: translate(TranslationEnum.manage_feedbacks, "View"),
      width: 80,
      renderCell: (params) => (
        <Button onClick={() => onViewClick(params.row.id)}>{translate(TranslationEnum.manage_feedbacks, "View")}</Button>
      ),
    },
  ];

  return (
    <div
      style={{
        height: 350,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DataGrid
        rows={filteredData }
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 5 }, // Set the initial page size
          },
        }}
        componentsProps={{
          pagination: {
            rowsPerPageOptions: [5, 10, 25], // Set the options for selecting number of rows per page
          },
        }}
        disableRowSelectionOnClick
        autoHeight={false}
      />
    </div>
  );
};

export default FeedbacksTable;
